import React from "react";
import TeacherPageContainer from "../../Container/TeacherPageContainer";
import ConfirmButton from "../../../Components/Buttons/ConfirmButton";
import { connect } from "react-redux";

function JobListing(props) {
  const { job, inst } = props.location.state;

  const tabs = [
    {
      text: "Search Jobs",
      pathname: "/JobBoard"
    },
    {
      text: "Saved Jobs",
      pathname: "/SavedJobs",
      disabled: true
    },
    {
      text: "My Applications",
      pathname: "/MyApplications"
    },
    {
      text: "Job Listing",
      pathname: "/JobListing/" + job._id,
      active: true
    }
  ]

  return (
    <TeacherPageContainer
      user={props.user}
      header="Job Board"
      tabs={tabs}
    >
      <div className="d-flex flex-column align-items-center">
        <h3>Thank you for your application.</h3>
        <p className="my-3">Your application for the <strong>{job.title}</strong> position has been received, and your profile has been sent to {inst.institution_name}. We recommend that you take this time to review/update the information on your profile and resume.</p>
        {/* <ConfirmButton
          className="mx-0"
          onClick={() => props.history.push(`/JobListing/${job._id}`)}
        >
          Review Job Listing
          </ConfirmButton> */}
        <ConfirmButton
          onClick={() => props.history.push("/")}
        >
          Review My Profile
          </ConfirmButton>
      </div>
    </TeacherPageContainer>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

export default connect(mapStateToProps)(JobListing);